import { indexOf, isUndefined, isNull, isArray } from 'lodash-es'

/**
* @desc Format a search query parameter.
* @param {string}      operator  - Operator of searching.
* @param {string|Array}  values    - Values of searching.
* @param {string}      [operand]  - Operand of searching.
*/
const formatSearch = (operator, values, operand) => {
  const searchFormatted = {}
  if (indexOf(['OR', 'AND', 'NOT'], operator.toUpperCase()) !== -1) {
    searchFormatted.operator = operator.toUpperCase()
    searchFormatted.conditions = values
  } else {
    searchFormatted.operation = operator
    if (!isUndefined(values) && !isNull(values)) {
      searchFormatted.values = isArray(values) ? values : [values]
    }
    searchFormatted.operand = operand
  }
  return searchFormatted
}

export default formatSearch
